import * as Actions from '../actions';

const initialState = {
    info: null,
    warning: null,
    error: null,
};

const RegisterReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.REGISTER_INFO:
            {
                return {
                    ...state,
                    info: action.payload
                };
            }
        case Actions.REGISTER_WARNING:
            {
                return {
                    ...state,
                    warning: action.payload
                };
            }
        case Actions.REGISTER_ERROR:
            {
                return {
                    ...state,
                    error: action.payload
                };
            }
        default:
            {
                return state
            }
    }
};

export default RegisterReducer;
